/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { Component, ChangeDetectionStrategy } from "@angular/core";
import { OnInit } from "@angular/core";
import { Input } from "@angular/core";
import { ElementRef } from "@angular/core";
import { ViewChild } from "@angular/core";
import { AfterViewInit } from "@angular/core";
import { RuiStore } from "@anvilor/ngx-rui";
import { IRuiControlComponent } from "@anvilor/ngx-rui";
import { SubscriptionGroup } from "@anvilor/ngx-core-utils";
import { AnvilorFormsApp } from "../../../store/anvilor-forms-app-store.service";
import { RecaptchaChallengeControl } from "./recaptcha-challenge-control";
import { RecaptchaService } from "../../../services/google-recaptcha.service";

@Component({
  selector: "app-recaptcha-challenge-control",
  templateUrl: "./recaptcha-challenge-control.component.html",
  styleUrls: ["./recaptcha-challenge-control.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RecaptchaChallengeControlComponent
  implements IRuiControlComponent, OnInit, AfterViewInit
{
  @Input() internalId!: string;
  control!: RecaptchaChallengeControl;

  @ViewChild("captchaWidgetOutlet") captchaWidgetOutlet?: ElementRef;

  private subscriptions: SubscriptionGroup;

  constructor(private rui: RuiStore, private app: AnvilorFormsApp) {
    this.subscriptions = new SubscriptionGroup();
  }

  ngOnInit() {
    this.control = new RecaptchaChallengeControl(this.rui, this.internalId);
  }

  async ngAfterViewInit() {
    await this.app.captcha.renderWidget(this.captchaWidgetOutlet!.nativeElement);
  }
}
